import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'vdo-map-tooltip',
  imports: [],
  templateUrl: './vdo-map-tooltip.component.html',
  styleUrl: './vdo-map-tooltip.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class VdoMapTooltipComponent {
  @Input() text = '';
}
